import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Wholesale from "../pages/wholesale/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    // Typed, refreshed, shared or bookmarked, /wholesale has to answer on its
    // own — scripts/prerender.mjs writes out/wholesale.html for exactly that.
    path: "/wholesale",
    element: <Wholesale />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
